import request from '@/utils/request'

export function getInventory(page_size, currentPage, branch, product, referencia, product_name) {
  return request({
    url: 'reports/getInventory/' + page_size + '?page=' + currentPage,
    method: 'get',
    params: {
      'branch':branch, 
      'product':product,
      'referencia':referencia,
      'product_name':product_name,
    }
  })
}

export function testD() {
  return request({
    url: 'reports/testD',
    method: 'get'
  })
}

export function dowloadInventory(data) {
  return request({
    url: 'reports/dowloadInventory',
    method: 'post',
    data,
    responseType: 'blob'
  });
}